import React, { useEffect, useState } from "react"
import Navbar from "./components/common/Navbar"
import Hero from "./components/sections/Hero"
import About from "./components/sections/About"
import Services from "./components/sections/Services"
import Contact from "./components/sections/Contact"
import Footer from "./components/common/Footer"
import LegalPage from "./components/common/LegalPage"
import { trackPageView } from './analytics'
import { useScrollDepthTracking } from './hooks/useScrollDepthTracking'
import {
	defaultLanguage,
	getTranslations,
	getSupportedLanguage,
	languageOptions,
} from "./i18n/translations"

const getInitialLanguage = () => {
	if (typeof window === "undefined") {
		return defaultLanguage
	}

	const storedLanguage = window.localStorage.getItem("preferredLanguage")
	const supportedStoredLanguage = getSupportedLanguage(storedLanguage)
	if (supportedStoredLanguage) {
		return supportedStoredLanguage
	}

	const browserLanguages = [
		...(window.navigator.languages || []),
		window.navigator.language,
	].filter(Boolean)

	for (const locale of browserLanguages) {
		const supportedLanguage = getSupportedLanguage(locale)
		if (supportedLanguage) {
			return supportedLanguage
		}
	}

	return defaultLanguage
}

// Main App Component
export default function App() {
	const logoUrl = "/web_logo.png"
	const [language, setLanguage] = useState(getInitialLanguage)
	const t = getTranslations(language)
	const path = typeof window === "undefined" ? "/" : window.location.pathname

	// 스크롤 깊이 추적
	useScrollDepthTracking()

	// 페이지 로드 추적
	useEffect(() => {
		trackPageView(path === "/privacy" ? "Privacy Policy" : path === "/terms" ? "Terms of Service" : "홈페이지")
	}, [path])

	useEffect(() => {
		document.documentElement.lang = language
		window.localStorage.setItem("preferredLanguage", language)
	}, [language])

	return (
		<div className="font-sans bg-white">
			<style>{`
				html {
					scroll-behavior: smooth;
				}
				.animate-fade-in-down {
					animation: fadeInDown 0.8s ease-out forwards;
				}
				.animate-fade-in-up {
					animation: fadeInUp 0.8s ease-out forwards;
				}
				.animation-delay-300 {
					animation-delay: 0.3s;
				}
				.animation-delay-600 {
					animation-delay: 0.6s;
				}
				@keyframes fadeInDown {
					0% {
						opacity: 0;
						transform: translateY(-20px);
					}
					100% {
						opacity: 1;
						transform: translateY(0);
					}
				}
				@keyframes fadeInUp {
					0% {
						opacity: 0;
						transform: translateY(20px);
					}
					100% {
						opacity: 1;
						transform: translateY(0);
					}
				}
			`}</style>
			{path === "/privacy" || path === "/terms" ? (
				<LegalPage type={path.slice(1)} />
			) : (
				<>
					<Navbar
						logoUrl={logoUrl}
						language={language}
						languageOptions={languageOptions}
						onLanguageChange={setLanguage}
						t={t.nav}
					/>
				<main>
					<Hero t={t.hero} />
					<About t={t.about} language={language} />
					<Services t={t.services} />
					<Contact t={t.contact} />
				</main>
				</>
			)}
			<Footer t={t.footer} />
		</div>
	)
}
